import {
    INSTALL_PROMPT_SET_READY,
    InstallPromptSetReadyAction,
} from 'mk2/containers/InstallPrompt/InstallPrompt.actions';
import { Reducer } from 'redux';

export interface State {
    ready: boolean;
}

const initialState: State = {
    ready: false,
};

const reducer: Reducer<State> = (state: State = initialState, action: InstallPromptSetReadyAction) => {
    switch (action.type) {
        case INSTALL_PROMPT_SET_READY:
            return {
                ...state,
                ready: action.ready,
            };
        default:
            return state;
    }
};

export default reducer;
